import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHeader, BrandButton } from "@/components/PageHeader";
import { ReportsManager } from "@/components/resources/ReportsManager";
import { AlbumsManager } from "@/components/resources/AlbumsManager";
import { api, errMsg } from "@/lib/api";

export default function ManageResources() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = () => api.get("/resources").then((r) => setData(r.data)).catch((e) => setError(errMsg(e)));
  useEffect(() => { load(); }, []);
  return <div data-testid="manage-resources-page">
    <PageHeader eyebrow="Control" title="Resources" description="Upload GAMLS Reports (PDF) and photo albums. Signed-in members and staff see them from the Resources button on the homepage."
      actions={<Link to="/resources" target="_blank"><BrandButton variant="outline" data-testid="manage-resources-open-public"><ExternalLink className="w-4 h-4" />Open Resources page</BrandButton></Link>} />
    {error ? <p role="alert" className="text-sm text-[#B30000]">{error}</p> : !data ? <div className="text-gray-500">Loading…</div> : (
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-start">
        <ReportsManager reports={data.reports} onChanged={load} />
        <AlbumsManager albums={data.albums} onChanged={load} />
      </div>
    )}
  </div>;
}
